// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"TYLcm","header":"cCb6R","heading":"_1uE25","close":"XGHDf","contentWrap":"_1LiRJ","detail":"JMHKo"};